import { Dialog } from "@progress/kendo-react-dialogs";
import { useState, useEffect } from "react";
import { useRemark } from "react-remark";
import { siteAPI } from "../../api/axios";
import "./Disclaimer.css";
import { useSelector, useDispatch } from "react-redux";
import { useHref, useSearchParams } from "react-router-dom";
import { setDisclaimerOpen } from "../../redux/toolSelectSlice";

const Disclaimer = () => {
    const [searchParams] = useSearchParams();
    const [reactContent, setMarkdownSource] = useRemark();
    const paramsToLower = new URLSearchParams(
        [...searchParams].map(([key, value]) => [key.toLowerCase(), value])
    );
    const autoAccept = paramsToLower.get("autoaccept");

    const [disclaimerShownCount, setDisclaimerShownCount] = useState(0);
    const dispatch = useDispatch();
    const disclaimerOpen = useSelector((state) => state.toolSelect.disclaimerOpen);

    useEffect(() => {
        if (disclaimerOpen === true) {
            setDisclaimerShownCount(disclaimerShownCount + 1);
        }
    }, [disclaimerOpen]);

    let domain = window.location.hostname.split(".")[0];
    useEffect(() => {
        if (autoAccept === "true") {
            dispatch(setDisclaimerOpen(false));
        }
        siteAPI
            .get(`sites/${domain}/basic`)
            .then((response) => {
                setMarkdownSource(response.data.DisclaimerText);
            })
            .catch((error) => {
                console.error("Error fetching disclaimer text:", error);
            });
    }, [dispatch, domain, autoAccept]);

    const handleAccept = (e) => {
        dispatch(setDisclaimerOpen(false));
    };

    return (
        <>
            {disclaimerOpen && (
                <Dialog
                    className={"centered-dialog"}
                    style={{ maxWidth: "50vw" }}
                    id="disclaimer-dialog">
                    <h2>Disclaimer</h2>
                    <div className="disclaimer-wrapper">
                        <div className="disclaimer-text">{reactContent}</div>
                    </div>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        onClick={handleAccept}>
                        Accept
                    </button>
                </Dialog>
            )}
        </>
    );
};
export default Disclaimer;
